import * as React from "react";
function SvgFolderFunnel(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
        d="M31 10V5H13L9 1H1v24h15"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
        d="M15 15h16l-6 7v9h-4v-9l-6-7z"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgFolderFunnel);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
